module.exports = __webpack_public_path__ + "assets/b750f49bdff2630c960f197f7de6a21e.mp3";